<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <div class="flex end actions">
            <div class="button secondary" @click="openModalNew()">
              Adicionar novo campo personalizado
            </div>
        </div>
        <ul class="margin-top-s">
          <li v-if="false">
            <small>
              Adicione sua primeira mensagem para começar a rodar sua campanha.
            </small>
          </li>
          <li v-for="(m, k) in customFields" :key="k">
            <div class="flex middle">
              <div class="flex-2">
                {{ m.name_key }} <span class="tag">{{ m.custom_type }}</span>
              </div>
              <div class="flex-1 flex end">
                <div class="button secondary" @click="openModalEdit(m)">
                  Editar
                </div>
                <div class="button secondary" @click="openModalDelete(m.id)">
                  Deletar
                </div>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <a @click="closeModal()" class="button secondary medium">
            Fechar
          </a>
        </div>
      </div>
    </modal>
    <!-- new list -->
    <new-custom-field
      :show="showEditModal"
      :cf="newCustomField"
      @close="
        showEditModal = false;
        newCustomField = null;
      "
      @accept="newOrEditCustomField($event)"
    ></new-custom-field>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar esse campo personalizado?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeCustomField(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import { getCustomFields, createCustomField, updateCustomField, removeCustomField } from "@/services/customfield";

import Modal from "@/components/modal/Modal";
import NewCustomField from './NewCustomField.vue';
import ModalConfirm from "@/components/modal/ModalConfirm";

const auxCustomField = {
  name_key: ''
}

export default {
  name: "modal-custom-fields",
  props: {
    titleName: {
      required: false,
      default: "Campos Personalizados",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    cf: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    NewCustomField,
    ModalConfirm,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      newCustomField: null,
      showEditModal: false,
      showModal: false,
      seenGuide: {},
      title: "Campos Personalizado",
      customFields: [],
  }
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.getCustomFields();
  },
  computed: {
    isEdit() {
      return this.cf && this.cf.id;
    },
  },
  methods: {
    newOrEditCustomField(auxCf) {
      this.showEditModal = false
      this.newCustomField = null

      if (auxCf.id) {
        return this.updateCustomField(auxCf)
      } 

      return this.createCustomField(auxCf)
    },
    openModalEdit(cfAux) {
      this.showEditModal = true
      this.newCustomField = cfAux
    },
    openModalNew() {
      this.showEditModal = true
      this.newCustomField = Object.assign({}, auxCustomField)
    },
    openModalDelete(cfID) {
      this.showDeleteModal = true
      this.selectModalDelete = cfID
    },
    getCustomFields() {
      getCustomFields()
        .then((result) => {
          this.customFields = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar campos personalizados",
          });
        });
    },
    createCustomField(cf) {
      createCustomField(cf)
        .then((result) => {
          this.customFields.push(result);
          this.$toast.success({
            title: "Sucesso",
            message: "Campo personalizado criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar campo personalizado",
          });
        });
    },
    updateCustomField(cf) {
      updateCustomField(cf.id, cf)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Campo Personalizado editada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao editar campo personalizado",
          });
        });
    },
    removeCustomField(cfId) {
      removeCustomField(cfId)
        .then(() => {

          this.customFields = this.customFields.filter(l => l.id != cfId)
          this.$toast.success({
            title: "Sucesso",
            message: "Campo personalizado removido com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover campo personalizado",
          });
        })
        .finally(() => {
          this.showDeleteModal = false
          this.selectModalDelete = null
        })
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.tag);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>


.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 350px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
